<style>
.field {
    padding: 5px;
}

textarea {
    width: 100%;
    height: 100px;
}

input {
    width: 250px;
    margin-top: 5px;
}
</style>

<script>
import {push} from './pt-router/Router.svelte'
import { getContext } from 'svelte';
import * as Common from './Common.js'
import ChangePasswordModal from './AccountManagement/ChangePasswordModal.svelte'
import DeleteAccountModal from './AccountManagement/DeleteAccountModal.svelte'
import AccountUpdateModal from './AccountManagement/AccountUpdateModal.svelte'

const { open } = getContext('simple-modal');

let user;
let allowMail;

const unsubsribe = Common.currentUser.subscribe(value => {
    user = value
    allowMail = !user.user_mailoff
})

function deleteAccount(currentPassword) {
    let userDelete = {
        current_password: currentPassword
    }

    Common.deleteData('user', userDelete)
    .then(r => {
        if(!r.ok) {
            alert("Problem deleting account. Please try again.")
            return
        }
        Common.CreateNotification({body: "Farewell!"}, 1000)
        Common.logUserOut();
        push('/')
    })
}

function updateAccount(currentPassword) {
    user.user_mailoff = !allowMail
    let userUpdate = {
        current_password: currentPassword,
        user : user
    }

    console.log(userUpdate)

    Common.putData('user', userUpdate)
    .then(r => {
        if(!r.ok) {
            if(r.code == 406) {
                alert("Username taken.")
            } else if(r.code == 400) {
                alert("Email already associated with another account.")
            } else {
                 alert("Could not update your account. Try again!")
            }
            return
        }
        
        Common.CreateNotification({body: "Account updated!"}, 1000)
        Common.currentUser.update(u => user)
        push("/user/" + user.user_id)
    })
}

function changePassword(oldPassword, newPassword) {
    user.user_password = newPassword
    updateAccount(oldPassword)
}

function showPasswordChangeModal() {
    open(ChangePasswordModal, {changePassword: changePassword}, {content: { fontSize: '14px', lineHeight: '1.5em'}});
}

function showDeleteAccountModal() {
    open(DeleteAccountModal, {deleteAccount: deleteAccount}, {content: { fontSize: '14px', lineHeight: '1.5em'}});
}

function showAccountUpdateModal() {
    open(AccountUpdateModal, {updateAccount: updateAccount}, {content: { fontSize: '14px', lineHeight: '1.5em'}});
}
</script>

{#if user}
<div class="holder">
    <h1>Personal Information</h1>
    <div class="field">
        <strong>User Name</strong><br>
        <input type="text" bind:value={user.user_name}>
    </div>
    <div class="field">
        <strong>Email</strong><br>
            {#if user.user_registration == Common.USER_REGISTRATION_GOOGLE}
                <input type="email" value={user.user_email} disabled>
            {:else}
                <input type="email" bind:value={user.user_email}>
            {/if}
    </div>
    <div class="field">
        <strong>Who are you?</strong><br>
        <input type="text" bind:value={user.user_occupation}>
    </div>
    <div class="field">
        <strong>Location</strong><br>
        <input type="text" bind:value={user.user_location}>
    </div>
    <div class="field">
        <strong>Bio</strong><br>
        <textarea bind:value={user.user_bio}></textarea>
    </div>
    <div class="field">
        <strong>Notifications and Newsletters</strong><br>
        <div>
            <input style="width: auto" type=checkbox bind:checked={allowMail}>
            {#if allowMail}
                <i>Email Updates are enabled.</i>
            {:else}
                <i>Email Updates are disabled.</i>
            {/if}
        </div>
    </div>
    <div class="field buttons">
        <button on:click={showAccountUpdateModal}>Update Account</button>
    </div>

    <h1>Account Administration</h1>
    <div class="field buttons">
        {#if user.user_registration == Common.USER_REGISTRATION_EMAIL}
        <button on:click={showPasswordChangeModal}>Change Password</button>
        {/if}
        <button on:click={showDeleteAccountModal}>Delete Account</button>
    </div>
</div>
{/if}